import React from 'react'
import { Spacer, Text, Heading, Grid } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import PaperPlane from '@percent/cause-dashboard/common/assets/images/paper-plane.png'
import { Button } from '@percent/lemonade'
import { VERIFICATION_DATA } from '@percent/cause-dashboard/constants/emailVerificationData'
import styles from './EmailVerificationDetail.module.scss'
import { HELP_LINK } from '@percent/cause-dashboard/constants/support'

type EmailVerificationDetailProps = {
  email?: string
  handleResendEmailSubmit?: () => void
  loading?: boolean
  success?: boolean
}

export function EmailVerificationDetail({
  email,
  handleResendEmailSubmit,
  loading,
  success
}: EmailVerificationDetailProps) {
  const { t } = useTranslation()

  return (
    <Grid className={styles.container}>
      <Grid.Col>
        <Grid>
          <img src={PaperPlane} alt="paper plane" />
        </Grid>
        <Spacer axis="vertical" size={6} />
        <Heading level="h4">{t(VERIFICATION_DATA.title)}</Heading>
        <Spacer axis="vertical" size={6} />
        <Text align="left" size="small">
          {email ? (
            <>
              {t('emailVerification.verificationData.paragraph1')}
              <b>{email}</b>
              {t('emailVerification.verificationData.paragraph2')}
            </>
          ) : (
            t('emailVerification.verificationData.paragraphWithoutEmail')
          )}
        </Text>
        <Spacer axis="vertical" size={6} />
        <Text align="left" size="small">
          {t('emailVerification.verificationData.paragraph3')}{' '}
          <span>
            <a href={HELP_LINK} className={styles.helpCenterLink}>
              {t('emailVerification.verificationData.paragraph4')}
            </a>
            .
          </span>
        </Text>
        {handleResendEmailSubmit && (
          <>
            <Spacer axis="vertical" size={8} />
            <Button
              size="large"
              data-testid="resend-email-button"
              disabled={loading || success}
              onClick={handleResendEmailSubmit}
              stretch
            >
              {t(VERIFICATION_DATA.mainButtonTitle)}
            </Button>
          </>
        )}
      </Grid.Col>
    </Grid>
  )
}
